import React from 'react';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import {replace, push} from "react-router-redux";
import { NotificationManager } from 'react-notifications';

import UserRoles from "../../../../../common/src/enums/UserRoles";
import {
    ROUTE_CHAMPIONSHIP, ROUTE_CHAMPIONSHIPS,
    ROUTE_CLUB, ROUTE_CLUBS,
} from '../../../constants/routeconstants';
import * as AdminActions from "../../../actions/admin";

import {confirm} from "../../../utils/confirmDialog";

import {hasCommonProps} from "../../../utils/Util";
import {flatten} from "../../../../../common/src/util/arrayUtil";
import UserFieldDataType from "../../../utils/enums/UserFieldDataTypeEnum";
import UserFieldElement from "../../reusable/UserFieldElement";
import ChampionshipGeneral from "./subPages/ChampionshipGeneral";
import ChampionshipRaces from "./subPages/ChampionshipRaces";
import ChampionshipPigeons from "./subPages/ChampionshipPigeons";

class ChampionshipPage extends React.Component {

    static getId() {
        return ROUTE_CHAMPIONSHIP;
    }

    static getAllowedRoles() {
        return [UserRoles.MAIN_ADMIN, UserRoles.SECTION_ADMIN, UserRoles.CLUB_ADMIN]; // empty means allowed for all
    }

    constructor(props) {
        super(props);
        this.state = {
            editId: null,
        }
    }

    componentDidMount() {
        this.loadChampionship(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.params.championshipNo !== this.props.params.championshipNo) this.loadChampionship(nextProps);
    }

    loadChampionship = newestProps => {
        if (newestProps.params.championshipNo.toLowerCase() !== 'new') newestProps.dispatch(AdminActions.getChampionship(newestProps.params.championshipNo, () => {this.forceUpdate();}));
    };

    subForm = null;
    fields = [];
    render() {
        const disabled = this.props.params.subpage === 'dist-zones' && this.state.editId !== null;

        // Get club from Redux state.
        const championshipNo = this.props.params.championshipNo;
        const championship = championshipNo.toLowerCase() === 'new' || !this.props.admin.championships ? null : this.props.admin.championships.get(Number(championshipNo)) || null;
        if (championshipNo.toLowerCase() !== 'new' && (championship === null || typeof(championship.isFullLoaded) === 'undefined')) return null;

        let subPage = null;
        switch (this.props.params.subpage) {
            case 'general':
                subPage = <ChampionshipGeneral championship={championship} editMode={this.props.params.mode === 'edit' || this.props.params.mode === 'create'} ref={instance => {this.subForm = instance;}}/>
                break;
            case 'races':
                subPage = <ChampionshipRaces championship={championship} editMode={this.props.params.mode === 'edit' || this.props.params.mode === 'create'} ref={instance => {this.subForm = instance;}}/>
                break;
            case 'pigeons':
                subPage = <ChampionshipPigeons championship={championship} editMode={this.props.params.mode === 'edit' || this.props.params.mode === 'create'} ref={instance => {this.subForm = instance;}}/>
                break;
            case 'dist-zones':
                subPage = <table className="data-table championship-dist-zones">
                    <thead>
                        <tr>
                            <th>Titel</th>
                            <th>Fra</th>
                            <th>Til</th>
                            <th/>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        championship === null ? [] : championship.MesterskabAfstZones.sort((z1, z2) => {
                            if (z1.Zone < z2.Zone) return -1;
                            if (z1.Zone > z2.Zone) return 1;
                            if (z1.Fra === null && z2.Fra !== null) return -1;
                            if (z1.Fra !== null && z2.Fra === null) return 1;
                            if (z1.Fra !== null && z2.Fra !== null && z1.Fra < z2.Fra) return -1;
                            if (z1.Fra !== null && z2.Fra !== null && z1.Fra > z2.Fra) return 1;
                            if (z1.Til === null && z2.Til !== null) return -1;
                            if (z1.Til !== null && z2.Til === null) return 1;
                            if (z1.Til !== null && z2.Til !== null && z1.Til < z2.Til) return -1;
                            if (z1.Til !== null && z2.Til !== null && z1.Til > z2.Til) return 1;
                            if (z1.Titel === null && z2.Titel !== null) return -1;
                            if (z1.Titel !== null && z2.Titel === null) return 1;
                            if (z1.Titel !== null && z2.Titel !== null && z1.Titel < z2.Titel) return -1;
                            if (z1.Titel !== null && z2.Titel !== null && z1.Titel > z2.Titel) return 1;
                            return 0;
                        }).concat(this.state.editId === 'new' ? [{Zone: 'new'}] : []).map((zone, ix) => {
                            if (this.state.editId === null || zone.Zone !== this.state.editId)
                                return <tr key={ix} id={'row-' + zone.Zone}>
                                    <td>{zone.Titel === null ? '' : zone.Titel}</td>
                                    <td>{zone.Fra === null ? '' : zone.Fra}</td>
                                    <td>{zone.Til === null ? '' : zone.Til}</td>
                                    <th>
                                        <i className={"fa fa-pencil " + (this.state.editId === null ? 'clickable' : 'disabled')} title="Rediger afstandszone" onClick={() => {
                                            if (this.state.editId === null) {
                                                this.setState({
                                                    editId: zone.Zone,
                                                    zoneTitel: zone.Titel === null ? '' : zone.Titel,
                                                    zoneFra: zone.Fra === null ? '' : String(zone.Fra),
                                                    zoneTil: zone.Til === null ? '' : String(zone.Til),
                                                });
                                            }
                                        }}/>
                                        <i className={"fa fa-trash " + (this.state.editId === null ? 'clickable' : 'disabled')} title="Slet afstandszone" onClick={() => {
                                            if (this.state.editId === null) confirm("Slet", <span>Ønsker du at slette afstandszonen <b>{zone.Titel}</b>?</span>, () => {
                                                this.props.dispatch(AdminActions.deleteChampionshipDistZone(this.props.params.championshipNo, zone.Zone, () => {
                                                    NotificationManager.success("Afstandszonen er slettet.", "Sletning", 4000);
                                                }));
                                            });
                                        }}/>
                                    </th>
                                </tr>;
                            else
                                return <tr key={ix}>
                                    <td>
                                        <UserFieldElement dataType={UserFieldDataType.string} placeholder="" className="field200" containerClassName="display-inline-block"
                                                          name="zoneTitel" id="zoneTitel" maxLength="20" value={this.state.zoneTitel}
                                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          onChange={this.onStandardFieldChange}
                                                          ref={instance => { this.fields[10] = instance; }}
                                        />
                                    </td>
                                    <td>
                                        <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field75" containerClassName="display-inline-block"
                                                          name="zoneFra" id="zoneFra" maxLength="5" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{1,5}"}]} value={this.state.zoneFra}
                                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          onChange={this.onStandardFieldChange}
                                                          ref={instance => { this.fields[11] = instance; }}
                                        />
                                    </td>
                                    <td>
                                        <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field75" containerClassName="display-inline-block"
                                                          name="zoneTil" id="zoneTil" maxLength="5" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{1,5}"}]} value={this.state.zoneTil}
                                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          onChange={this.onStandardFieldChange}
                                                          ref={instance => { this.fields[12] = instance; }}
                                        />
                                    </td>
                                    <th>
                                        <i className="fa fa-save clickable" title="Gem afstandszone" onClick={() => {
                                            this.saveDistZone();
                                        }}/>
                                        <i className="fa fa-undo clickable" title="Annuller" onClick={() => {
                                            this.setState({editId: null});
                                        }}/>
                                    </th>
                                </tr>;
                        })
                    }
                    </tbody>
                </table>;
                break;
        }

        return (<div>
            <div className="sub-page-title">
                <h2>{championshipNo.toLowerCase() === 'new' ? 'Nyt mesterskab' : 'Mesterskab ' + championship.Nr + ' - ' + championship.Titel}</h2>
            </div>
            <div className="sub-page-content">
                <div className="tab-list">
                    <Link className={(this.props.params.subpage === 'general' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !disabled ? '' : ' disabled'))} to={this.props.params.mode === 'view' && !disabled ? ROUTE_CHAMPIONSHIP.replace(":championshipNo", championshipNo).replace(":subpage", "general").replace(":mode", "view") : ''}>
                        <span className="tab-text">Generelt</span>
                    </Link>
                    <Link className={(this.props.params.subpage === 'races' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !disabled ? '' : ' disabled'))} to={this.props.params.mode === 'view' && !disabled ? ROUTE_CHAMPIONSHIP.replace(":championshipNo", championshipNo).replace(":subpage", "races").replace(":mode", "view") : ''}>
                        <span className="tab-text">Kapflyvninger</span>
                    </Link>
                    <Link className={(this.props.params.subpage === 'pigeons' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !disabled ? '' : ' disabled'))} to={this.props.params.mode === 'view' && !disabled ? ROUTE_CHAMPIONSHIP.replace(":championshipNo", championshipNo).replace(":subpage", "pigeons").replace(":mode", "view") : ''}>
                        <span className="tab-text">Deltagende duer</span>
                    </Link>
                    <Link className={(this.props.params.subpage === 'dist-zones' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !disabled ? '' : ' disabled'))} to={this.props.params.mode === 'view' && !disabled ? ROUTE_CHAMPIONSHIP.replace(":championshipNo", championshipNo).replace(":subpage", "dist-zones").replace(":mode", "view") : ''}>
                        <span className="tab-text">Afstandszoner</span>
                    </Link>
                </div>
                <div className="tab-page" id="sub-page-content">
                    {subPage}
                </div>
            </div>
            <div className="sub-page-actions">
                {this.props.params.mode === 'view' ? [
                    <span className="left-buttons" key="left">
                        {this.props.params.subpage === 'general' ? [
                            <button key={0} className="btn-primary" title="Rediger forening" onClick = {() => {
                                this.props.dispatch(replace(ROUTE_CHAMPIONSHIP.replace(':championshipNo', championshipNo).replace(':subpage', this.props.params.subpage).replace(':mode', 'edit')));
                            }}>Rediger</button>,
                            <button key={1} className="btn-primary" title="Opdater kapflyvn." disabled={this.props.params.mode === 'edit'} onClick = {() => {
                                if (this.props.params.mode !== 'edit') confirm("Opdater kapflyvninger", <span>Ønsker du at overføre indstillingerne til kapflyvningerne i mesterskabet?</span>, () => {
                                    this.props.dispatch(AdminActions.updateChampionshipRaces(championshipNo, () => {
                                        NotificationManager.success(`Kapflyvningerne i mesterskaber er opdateret`, "Opdatering", 4000);
                                    }));
                                });
                            }}>Opdater kapflyvn.</button>
                        ] : null}

                        {this.props.params.subpage === 'races' ? [
                                <button key={0} className="btn-primary" title="Generer. langdist" onClick = {() => {
                                    this.props.dispatch(AdminActions.createChampionshipRaces(championshipNo,0, () => this.championshipRacesButtonSuccess(0)));
                                }}>Generer. langdist</button>,
                                <button key={1} className="btn-primary" title="Mellemdist, (sport)" onClick = {() => {
                                    this.props.dispatch(AdminActions.createChampionshipRaces(championshipNo, 1, () => this.championshipRacesButtonSuccess(1)));
                                }}>Mellemdist, (sport)</button>,
                                <button key={2} className="btn-primary" title="Mellemdist, (åben)" onClick = {() => {
                                    this.props.dispatch(AdminActions.createChampionshipRaces(championshipNo,2, () => this.championshipRacesButtonSuccess(2)));
                                }}>Mellemdist, (åben)</button>,
                                <button key={3} className="btn-primary" title="Generer jun./beg." onClick = {() => {
                                    this.props.dispatch(AdminActions.createChampionshipRaces(championshipNo,3, () => this.championshipRacesButtonSuccess(3)));
                                }}>Generer jun./beg.</button>,
                                <button key={4} className="btn-primary" title="Tilføj alle kapfl." onClick = {() => {
                                    this.props.dispatch(AdminActions.createChampionshipRaces(championshipNo,4, () => this.championshipRacesButtonSuccess(4)));
                                }}>Tilføj alle kapfl.</button>
                            ] : null}
                        {this.props.params.subpage === 'dist-zones' ?
                            <button className={"btn-primary" + (this.state.editId === null ? '' : ' disabled')} title="Opret ny ringserie" onClick = {() => {
                                if (this.state.editId === null) {
                                    this.setState({
                                        editId: 'new',
                                        zoneTitel: '',
                                        zoneFra: '',
                                        zoneTil: '',
                                    });
                                    setTimeout(function () {
                                        const content = document.getElementById("sub-page-content");
                                        content.scrollTop = content.scrollHeight;
                                    });
                                }
                            }}>Ny</button> : null
                        }
                    </span>,
                    <span className="right-buttons" key="right">
                        <Link className={"btn-primary" + (disabled ? ' disabled' : '')} to={disabled ? '' : ROUTE_CHAMPIONSHIPS} title="Vis alle mesterskaber">
                            Mesterskaber
                        </Link>
                    </span>
                ] : this.props.params.subpage !== 'races' ? [
                    <span className="left-buttons" key="left">
                        <button className="btn-primary" title="Gem ændringer" onClick = {() => {
                            this.subForm.getWrappedInstance().save(championshipNo => {
                                NotificationManager.success(this.props.params.championshipNo.toLowerCase() === 'new' ? "Mesterskabet er oprettet" : "Mesterskabet er opdateret.", this.props.params.championshipNo.toLowerCase() === 'new' ? "Oprettelse" : "Opdatering", 4000);
                                this.props.dispatch(replace(ROUTE_CHAMPIONSHIP.replace(':championshipNo', championshipNo).replace(':subpage', this.props.params.subpage).replace(':mode', 'view')));
                            })
                        }}>Gem</button>
                    </span>,
                    <span className="right-buttons" key="right">
                        <button className="btn-secondary" title="Annuller ændringer" onClick = {() => {
                            if (championshipNo.toLowerCase() === 'new') this.props.dispatch(replace(ROUTE_CHAMPIONSHIPS));
                            else this.props.dispatch(replace(ROUTE_CHAMPIONSHIP.replace(':championshipNo', championshipNo).replace(':subpage', this.props.params.subpage).replace(':mode', 'view')));
                        }}>Annuller</button>
                    </span>,
                ]: null}
            </div>
        </div>);
    }

    allInputValid = () => {
        //return true;
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    championshipRacesButtonSuccess = (type) => {
        const string = type === 0 ? 'langdistance'
                      :type === 1 ? 'mellemdistance (sport)'
                      :type === 2 ? 'mellemdistance (åben)'
                      :type === 3 ? 'mellem- og langdistance'
                      :'alle'
        NotificationManager.success(`Kapflyvningerne i mesterskabet er opdateret med ${string} kapflyvninger`, "Opdatering", 4000);
    };

    saveDistZone = () => {
        if (this.allInputValid()) {
            const entity = {
                Titel: this.state.zoneTitel === '' ? null : this.state.zoneTitel,
                Fra: this.state.zoneFra === '' ? null : Number(this.state.zoneFra),
                Til: this.state.zoneTil === '' ? null : Number(this.state.zoneTil),
            };
            if (this.state.editId === 'new') this.props.dispatch(AdminActions.createChampionshipDistZone(this.props.params.championshipNo, entity, () => {
                NotificationManager.success("Afstandszonen er oprettet.", "Oprettelse", 4000);
                this.setState({editId: null});
            })); else this.props.dispatch(AdminActions.updateChampionshipDistZone(this.props.params.championshipNo, this.state.editId, entity, () => {
                NotificationManager.success("Afstandszonen er opdateret.", "Opdatering", 4000);
                this.setState({editId: null});
            }));
        }  else {
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    }
}

const mapStateToProps = (state) => ({
    admin: {
        championships: state.admin.championships,
    }
});

export default connect(mapStateToProps)(ChampionshipPage);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/championships/ChampionshipPage.js